import { nanoid } from 'nanoid';
import { useLocalStorage } from 'react-use';

type AnonymousId = string;

const ANONYMOUS_ID_KEY = 'anonymousId';

const useAnonymousId = () => {
  const [anonymousId] = useLocalStorage<AnonymousId>(ANONYMOUS_ID_KEY, nanoid(), { raw: true });

  return { anonymousId };
};

export default useAnonymousId;
